import React, { Component } from "react";

import main from "../images/requirements/main-img.png"
import step1 from "../images/requirements/step1.png";
import step1a from "../images/requirements/step1a.png";
import step2 from "../images/requirements/step2.png";
import step3 from "../images/requirements/step3.png";
import step3a from "../images/requirements/step3a.png";
import desktopstep1 from "../images/requirements/desktop-step1.png";
import desktopstep2 from "../images/requirements/desktop-step2.png";
import desktopstep3 from "../images/requirements/desktop-step3.png";
import desktopstep4 from "../images/requirements/desktop-step4.png";
import desktopstep4a from "../images/requirements/desktop-step4a.png";
import desktopstep4b from "../images/requirements/desktop-step4b.png";
import desktopstep4c from "../images/requirements/desktop-step4c.png";
import desktopstep4d from "../images/requirements/desktop-step4d.png";
import desktopstep5 from "../images/requirements/desktop-step5.png";


class Requirements extends Component {
    render() {
        return (
            <div className="template-flex">
                <div className="skill-home scrollable">
                    <div className="tp-title">
                        <h3>Supervity Software Requirements</h3>
                    </div>
                    <div className="doc-text">
                        <h4>OS Compatibility:</h4>
                        <ul>
                            <li><strong>On-Premise:</strong> Windows 10 / Windows Server 2016 and above</li>
                            <li><strong>GCP:</strong> Windows Server 2016 Data Center / Windows Server 2016 Data Center Core and above</li>
                            <li><strong>MS Azure:</strong> Windows 10 Pro Ver 1809, 1803 / Windows Server 2016 Data Center and above</li>
                            <li><strong>AWS:</strong> Microsoft Windows Server 2016 Base and above</li>                                    
                        </ul>
                        <h4>Hardware Requirements:</h4>
                        <ol>
                            <li>Processor: Intel Core i5 2.6GHz</li>
                            <li>RAM: 8GB</li>
                            <li>Storage: 10GB</li>
                            <li>Others: Microsoft .Net Framework 4.6(Windows 10 and Windows Server 2016 and above).</li>
                        </ol>
                        <h4>Supervity Dependencies Installation Steps</h4>
                        <p>There are 2 types of dependencies for Supervity. The browser plug-in which is used for the web-based automations wherein we support chrome and edge browsers and the desktop app which is used for the desktop-based automations wherein we support the windows operating system.</p>
                        <div className="doc-img">
                            <img src={main} />
                        </div>
                        <h4>Steps for installing browser plug in</h4>
                        <h4>Step 1:</h4>
                        <p>Upon login click on the web icon in the bottom middle menu, and click on proceed to begin the process.</p>
                        <div className="doc-img"></div>
                        <img src={step1} />
                        <img src={step1a} />
                        <h4>Step 2:</h4>
                        <p>A notice will appear for enabling the super web extension and will automatically navigate to the browser extension store, if it doesn't then click on the link given in the pop-up to open your browser extension store.</p>
                        <div className="doc-img"></div>
                        <img src={step2} />
                        <h4>Step 3</h4>
                        <p>Click on Add to Chrome in the extensions page, read the instruction and click on Add extension. Navigate back to super and click on Close to proceed to the next step.</p>
                        <div className="doc-img"></div>
                        <img src={step3} />
                        <img src={step3a} />

                        <h4>Steps for installing desktop plug in</h4>
                        <h4>Step 1:</h4>
                        <p>Click on the windows icon in the bottom middle menu, and click on proceed to begin the process.</p>
                        <div className="doc-img"></div>
                       <img src={desktopstep1} />
                        <h4>Step 2:</h4>
                        <p>Click on “I Enabled it” to confirm the installation of browser plug in.</p>
                        <div className="doc-img"></div>
                        <img src={desktopstep2} />
                        <h4>Step 3:</h4>
                        <p>A download of our windows exe file will automatically begin, if it doesn't, pls click on the link to download it manually.</p>
                        <div className="doc-img"></div>
                        <img src={desktopstep3} />
                        <h4>Step 4:</h4>
                        <p>Once the download is complete double click on the downloaded exe file to proceed with the desktop plug-in installation. Follow the on-screen instructions on the installation wizard to finish the installation process. This might take 5 minutes. Click on the finish button to close the installation wizard.</p>
                        <div className="doc-img">
                            <img src={desktopstep4} />
                            <img src={desktopstep4a} />
                            <img src={desktopstep4b} />
                            <img src={desktopstep4c} />
                            <img src={desktopstep4d} />
                        </div>
                        <h4>Step 5:</h4>
                        <p>Navigate back to the Super browser window and click on I installed it. Your device is now connected to super and you can see your email id when you click on download icons.</p>
                        <div className="doc-img"></div>       
                        <img src={desktopstep5} />   
                    </div>
                </div>
            </div>
        );
    };
}

export default Requirements;